module.exports = __webpack_public_path__ + "img/attribute_mark_2_on.cb4b6f3.png";